// pages/formularios/modelos.js — os modelos de partida da tela Formulários.
//
// Out/26. Os mesmos que a Meta oferece no "Criar flow" do Gerenciador do
// WhatsApp, com o mesmo nome em português pra quem já viu lá reconhecer:
// Padrão, Coletar interesse de compra, Obter feedback, Enviar uma pesquisa
// e Suporte ao cliente. O CONTEÚDO é nosso, em português e dentro dos
// limites da Meta (rótulo de texto até 20 caracteres, opção até 30) — o da
// Meta é em inglês e não preenche o CRM.
//
// Os "Conectados à Cetto" (com servidor — o "com ponto de extremidade" da
// Meta) aparecem bloqueados até a fase própria: precisam de chave de
// criptografia por número e de um servidor que responda em segundos. A
// definição deles existe só pra desenhar a miniatura.
//
// Cada `definicao()` gera ids novos a cada chamada: dois formulários
// criados do mesmo modelo não podem dividir id de bloco.

import { novoId } from './regras';

const t = (titulo, rodape, blocos) => ({ id: novoId(), titulo, rodape, blocos });
const conteudo = (estilo, texto) => ({ id: novoId(), tipo: 'conteudo', estilo, texto });
const campo = (tipo, rotulo, extra = {}) => ({
  id: novoId(), tipo, rotulo, obrigatorio: true, destino: 'campo', ...extra,
});

const NOTAS = ['★★★★★ Excelente', '★★★★ Bom', '★★★ Regular', '★★ Ruim', '★ Péssimo'];

export const MODELOS_SIMPLES = [
  {
    key: 'padrao',
    nome: 'Padrão',
    resumo: 'Uma tela para começar do zero.',
    categoria: 'OTHER',
    definicao: () => ({ telas: [
      t('Boas-vindas', 'Concluir', [
        conteudo('titulo', 'Olá! Que bom ter você aqui.'),
        conteudo('paragrafo', 'Responda rapidinho e a gente continua a conversa.'),
      ]),
    ] }),
  },
  {
    key: 'interesse',
    nome: 'Coletar interesse de compra',
    resumo: 'Do que o cliente gosta e se aceita ofertas.',
    categoria: 'LEAD_GENERATION',
    definicao: () => ({ telas: [
      t('Seus interesses', 'Continuar', [
        conteudo('subtitulo', 'O que você quer receber primeiro?'),
        campo('multipla', 'Tenho interesse em', { opcoes: ['Lançamentos', 'Promoções', 'Mais vendidos', 'Novidades da semana'] }),
        campo('lista', 'Com que frequência?', { opcoes: ['Toda semana', 'A cada 15 dias', 'Uma vez por mês'] }),
      ]),
      t('Seus dados', 'Enviar', [
        campo('texto', 'Nome', { destino: 'nome' }),
        campo('email', 'E-mail', { obrigatorio: false }),
        campo('aceite', 'Aceito receber ofertas pelo WhatsApp'),
      ]),
    ] }),
  },
  {
    key: 'feedback',
    nome: 'Obter feedback',
    resumo: 'Indicaria a um amigo? E notas do atendimento.',
    categoria: 'SURVEY',
    definicao: () => ({ telas: [
      t('Sua opinião', 'Continuar', [
        campo('unica', 'Você nos indicaria a um amigo?', { opcoes: ['Sim', 'Não'] }),
        campo('area', 'Deixe um comentário', { obrigatorio: false }),
      ]),
      t('Avalie', 'Enviar', [
        campo('lista', 'Nota da compra', { opcoes: NOTAS }),
        campo('lista', 'Nota da entrega', { opcoes: NOTAS }),
        campo('lista', 'Nota do atendimento', { opcoes: NOTAS }),
      ]),
    ] }),
  },
  {
    key: 'pesquisa',
    nome: 'Enviar uma pesquisa',
    resumo: 'Como conheceu a empresa e o que mais importa.',
    categoria: 'SURVEY',
    definicao: () => ({ telas: [
      t('Pesquisa rápida', 'Continuar', [
        conteudo('paragrafo', 'São 3 perguntas e leva menos de um minuto.'),
        campo('unica', 'Como nos conheceu?', { opcoes: ['Indicação', 'Instagram', 'Google', 'Passei na loja', 'Outro'] }),
        campo('multipla', 'O que mais te interessa?', { opcoes: ['Preço', 'Qualidade', 'Atendimento', 'Entrega rápida'] }),
      ]),
      t('Para terminar', 'Enviar', [
        campo('area', 'Algo mais a dizer?', { obrigatorio: false }),
      ]),
    ] }),
  },
  {
    key: 'suporte',
    nome: 'Suporte ao cliente',
    resumo: 'Pedido, assunto, descrição e foto do problema.',
    categoria: 'CUSTOMER_SUPPORT',
    definicao: () => ({ telas: [
      t('Fale com o suporte', 'Continuar', [
        campo('texto', 'Nome', { destino: 'nome' }),
        campo('texto', 'Número do pedido', { obrigatorio: false }),
        campo('lista', 'Assunto', { opcoes: ['Pedido e pagamento', 'Entrega', 'Troca ou devolução', 'Problema no produto', 'Outro'] }),
      ]),
      t('Conte o que houve', 'Enviar', [
        campo('area', 'Descreva o problema'),
        campo('foto', 'Foto do problema', { obrigatorio: false, maximo: 3, destino: 'nenhum', descricao: 'Ajuda a resolver mais rápido.' }),
        campo('aceite', 'Li e aceito os termos de atendimento'),
      ]),
    ] }),
  },
];

export const MODELOS_CONECTADOS = [
  {
    key: 'agendamento',
    nome: 'Agendamento com a Agenda',
    resumo: 'Mostra os horários livres e marca a consulta.',
    categoria: 'APPOINTMENT_BOOKING',
    bloqueado: true,
    definicao: () => ({ telas: [
      t('Agendar horário', 'Confirmar', [
        campo('lista', 'Serviço', { opcoes: ['Avaliação', 'Retorno'] }),
        campo('calendario', 'Dia'),
        campo('unica', 'Horários livres', { opcoes: ['09:00', '10:30', '14:00', '16:30'] }),
      ]),
    ] }),
  },
  {
    key: 'remarcacao',
    nome: 'Remarcar consulta',
    resumo: 'O cliente escolhe um novo horário livre.',
    categoria: 'APPOINTMENT_BOOKING',
    bloqueado: true,
    definicao: () => ({ telas: [
      t('Remarcar', 'Confirmar', [
        conteudo('paragrafo', 'Sua consulta está marcada para terça, 15:00.'),
        campo('calendario', 'Novo dia'),
        campo('unica', 'Horários livres', { opcoes: ['09:00', '11:00', '15:30'] }),
      ]),
    ] }),
  },
];

export const MODELO_POR_CHAVE = Object.fromEntries(
  [...MODELOS_SIMPLES, ...MODELOS_CONECTADOS].map((m) => [m.key, m])
);
